import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const Item = ({ label, children }) => (
    <div className="relative group">
      <button className="px-3 py-2 rounded-md hover:bg-white/10">
        {label}
      </button>
      {children && (
        <div className="absolute right-0 mt-2 hidden min-w-56 rounded-xl bg-white text-gray-800 shadow-xl group-hover:block">
          <div className="p-3 space-y-1">
            {children}
          </div>
        </div>
      )}
    </div>
  );

  const Link = ({ href="#", children }) => (
    <a href={href} className="block rounded-lg px-3 py-2 hover:bg-gray-100">
      {children}
    </a>
  );

  return (
    <header className="sticky top-0 z-50 bg-[#00A3E0] text-white">
      <div className="mx-auto flex h-16 max-w-[1700px] items-center justify-between px-3 md:px-6">
        <div className="flex items-center gap-3">
          <a href="/"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1375_4937)"><path d="M10.036 13.896C9.54699 13.5598 8.85274 13.5912 8.91547 12.8027C8.94683 12.4214 9.04662 12.2014 9.41156 12.0142C11.0809 11.156 12.7203 10.2472 14.401 9.3999C14.87 9.16211 15.0268 8.8888 15.0112 8.39682C14.9755 7.19833 14.9841 5.99847 15.0112 4.79997C15.0197 4.37633 14.9128 4.16314 14.4409 4.03741C12.5386 3.51809 10.5227 3.51809 8.62038 4.03741C8.21979 4.14537 8.10004 4.31073 8.10574 4.68927C8.12712 6.04629 8.12427 7.40468 8.10574 8.7617C8.09004 8.89374 8.11968 9.02709 8.19017 9.14152C8.26066 9.25595 8.36816 9.34522 8.49635 9.3958C9.27186 9.78254 10.0303 10.1994 10.8043 10.608C10.0516 11.3336 9.8321 11.376 8.99387 10.9209C8.31958 10.5547 7.36873 10.3838 7.04512 9.77024C6.7372 9.18944 6.94961 8.35583 6.94676 7.6329C6.94676 6.38794 6.96102 5.14435 6.93679 3.89939C6.92966 3.52494 7.04656 3.33772 7.42718 3.20653C10.2199 2.24308 12.9954 2.27588 15.7738 3.25709C16.1231 3.38008 16.2215 3.57141 16.2186 3.91169C16.2015 5.67595 16.1944 7.44158 16.2186 9.20584C16.2186 9.61582 16.0475 9.80578 15.7068 9.98207C14.1031 10.8143 12.5093 11.6616 10.9141 12.5048C10.1044 12.9284 10.1058 12.9312 10.036 13.896Z" fill="white"></path><path d="M11.9821 12.5881C12.3584 12.3749 12.5951 12.2287 12.8445 12.1043C13.4333 11.8105 13.9194 12.0838 13.9208 12.7234C13.9294 14.6011 13.9379 16.4774 13.9208 18.3537C13.9013 18.5291 13.9407 18.7058 14.0333 18.8582C14.1258 19.0106 14.2667 19.1307 14.4355 19.201C15.5284 19.7768 16.6099 20.3808 17.68 21.0131C18.0507 21.2304 18.2802 21.188 18.5952 20.9065C20.0212 19.6364 21.0591 18.0177 21.5975 16.2246C21.7229 15.8146 21.6659 15.5713 21.2439 15.35C20.1035 14.75 18.9816 14.12 17.8725 13.4668C17.5346 13.27 17.2823 13.3069 16.9672 13.4846C16.3158 13.8535 15.6386 14.1815 14.9814 14.5409C14.6507 14.7227 14.4967 14.7364 14.4768 14.2908C14.4526 13.7715 14.531 13.3616 15.1183 13.1812C15.2786 13.1371 15.4276 13.0618 15.5559 12.9598C16.8717 11.8324 18.102 12.077 19.4292 13.0213C20.4114 13.7196 21.5362 14.2362 22.6082 14.8142C22.9404 14.9946 23.0558 15.175 22.9774 15.5672C22.4328 18.2758 21.0244 20.4788 18.8162 22.2444C18.4299 22.5532 18.1376 22.5847 17.6929 22.3236C16.2202 21.4586 14.722 20.6345 13.218 19.8201C13.071 19.7552 12.9489 19.6478 12.8689 19.513C12.7889 19.3782 12.7549 19.2227 12.7718 19.0684C12.7889 17.2823 12.7633 15.4962 12.7889 13.71C12.7961 13.1948 12.7504 12.7671 11.9821 12.5881Z" fill="white"></path><path d="M12.237 14.7146C12.237 15.0767 12.237 15.3186 12.237 15.5591C12.2213 16.211 11.6426 16.5294 11.0367 16.211C9.31603 15.3063 7.59254 14.403 5.88472 13.4778C5.51264 13.2755 5.22325 13.2509 4.84833 13.4778C3.8205 14.0818 2.78127 14.6708 1.7121 15.2202C1.30724 15.4293 1.28442 15.6493 1.38849 16.0292C1.89098 17.8802 2.9328 19.5558 4.39215 20.8601C4.62879 21.0733 4.81269 21.1512 5.12346 20.9722C6.25821 20.318 7.40294 19.6803 8.55764 19.0589C8.68374 19.0026 8.78802 18.9094 8.85561 18.7929C8.92319 18.6763 8.95063 18.5422 8.93398 18.4098C8.9126 17.7101 8.94682 17.0077 8.92116 16.308C8.90405 15.827 9.07369 15.8557 9.45289 16.0224C9.9219 16.2301 10.1286 16.5021 10.083 17.0118C10.006 17.8399 10.3824 18.8212 9.94043 19.4716C9.51276 20.0839 8.55051 20.3558 7.81778 20.7699C6.89971 21.2865 5.96454 21.7716 5.06216 22.3169C4.7072 22.5342 4.49194 22.4781 4.19827 22.2485C1.97345 20.5193 0.484459 18.0703 0.0114028 15.3623C-0.0470451 15.0425 0.045612 14.869 0.336426 14.7091C1.87793 13.8636 3.41089 13.0068 4.93529 12.1385C5.24891 11.9595 5.47843 12.0019 5.77352 12.1645C7.36302 13.02 8.9682 13.844 10.5563 14.7009C11.0852 14.966 11.5827 15.2735 12.237 14.7146Z" fill="white"></path></g><defs><clipPath id="clip0_1375_4937"><rect width="23" height="20" fill="white" transform="translate(23 22.5) rotate(-180)"></rect></clipPath></defs></svg></a>
        </div>

        {/* desktop */}
        <nav className="hidden lg:flex items-center gap-4">
          <Item label="نبذة عن الشركة">
            <Link href="#">نبذة تاريخية</Link>
            <Link href="#">الفريق الإداري</Link>
            <Link href="#">حوكمة الشركات</Link>
          </Item>
          <Item label="خدمات الشركة">
            <Link href="/loan">قرض نقدي</Link>
            <Link href="/loan">قرض سيارة</Link>
            <Link href="/loan">قرض سكني</Link>
            <Link href="/loan">قرض تعليمي</Link>
          </Item>
          <Item label="الأخبار والمعلومات المالية">
            <Link href="#">تقارير مالية</Link>
            <Link href="#">نتائج الاجتماع</Link>
          </Item>
          <Item label="إتصل بنا">
            <Link href="#">الفروع</Link>
            <Link href="#">الأسئلة المشهورة</Link>
          </Item>

          <a href="#" className="rounded-md bg-white/10 px-4 py-2 text-sm hover:bg-white/20">
            English
          </a>
          <a href="#" className="rounded-md bg-white px-4 py-2 text-sm font-medium text-[#00A3E0] hover:bg-gray-100">
            تسجيل الدخول
          </a>
        </nav>

        {/* mobile */}
        <button onClick={() => setOpen(v => !v)} className="lg:hidden rounded-lg bg-white/10 p-2">
          <img src="/assets/menu.png" alt="menu" className="h-5 w-5 invert" />
        </button>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-white/20 bg-white text-gray-800">
          <div className="mx-auto max-w-[1700px] p-3 space-y-2">
            <details className="rounded-lg border p-2" open>
              <summary className="cursor-pointer p-1">نبذة عن الشركة</summary>
              <div className="mt-2 space-y-1 px-2 text-sm">
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">نبذة تاريخية</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">الفريق الإداري</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">حوكمة الشركات</a>
              </div>
            </details>

            <details className="rounded-lg border p-2">
              <summary className="cursor-pointer p-1">خدمات الشركة</summary>
              <div className="mt-2 space-y-1 px-2 text-sm">
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">قرض نقدي</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">قرض سيارة</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">قرض سكني</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">قرض تعليمي</a>
              </div>
            </details>

            <details className="rounded-lg border p-2">
              <summary className="cursor-pointer p-1">الأخبار والمعلومات المالية</summary>
              <div className="mt-2 space-y-1 px-2 text-sm">
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">تقارير مالية</a>
                <a className="block rounded px-2 py-1 hover:bg-gray-100" href="#">نتائج الاجتماع</a>
              </div>
            </details>

            <a className="block rounded-lg border p-2 text-center" href="#">اتصل بنا</a>
            <div className="flex gap-2">
              <a href="#" className="flex-1 rounded-md bg-[#008fcc] px-4 py-2 text-center text-white">English</a>
              <a href="#" className="flex-1 rounded-md bg-[#00A3E0] px-4 py-2 text-center text-white">تسجيل الدخول</a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
